import styled, { css } from 'styled-components'

export const HiddenInput = styled.input(
  () => css`
    display: none;
  `,
)
